export const form = {
	language: {
		vi: {
			placeholder: 'Chọn ảnh',
			button: 'Chọn ảnh'
		},
		en: {
			placeholder: 'Select image',
			button: 'Select image'
		}
	},
	select2: function () {
		$('.form-select-2 select').each(function () {
			const placeholder = $(this).attr('placeholder');
			$(this).select2({
				placeholder: placeholder,
				allowClear: true,
				language: {
					noResults: function () {
						return "Không có kết quả";
					}
				}
			});
		});
	},
	inputDate: () => {
		$('.form-date input').each(function () {
			$(this).daterangepicker({
				singleDatePicker: true,
				parentEl: $(this).parent(),
				autoApply: true,
				autoUpdateInput: false,
				showDropdowns: true,
				locale: {
					format: 'DD/MM/YYYY',
					separator: ' - ',
					applyLabel: 'Áp dụng',
					cancelLabel: 'Hủy',
					fromLabel: 'Từ',
					toLabel: 'Đến',
					customRangeLabel: 'Tùy chỉnh',
					weekLabel: 'T',
					daysOfWeek: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
					monthNames: [
						'Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6',
						'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'
					],
					firstDay: 1
				}

			});
			$(this).on('apply.daterangepicker', function (ev, picker) {
				const date = picker.startDate.format('YYYY-MM-DD');
				$(this).val(date);
			});
		});
	},
	updateFileInput: function (fileInput, filesArray) {
		// Create a new DataTransfer object to update the file input
		const dt = new DataTransfer();
		filesArray.forEach(file => dt.items.add(file));
		fileInput.files = dt.files;
	},
	i18n: (key, lang = 'vi') => {
		const langCurrent = $('html').attr('lang') || 'vi';
		return form.language[langCurrent][key];
	},
	inputFile: function () {
		$('.form-input-image input[type="file"]').each(function () {
			const $input = $(this);
			const $formGroup = $input.closest('.form-input-image');

			$input.on('change', function (e) {
				const file = e.target.files[0];

				// Clear existing previews
				$formGroup.find('.preview-image').remove();

				if (file && file.type.startsWith('image/')) {
					const reader = new FileReader();
					reader.onload = function (e) {
						const previewHtml = `
							<div class="preview-image">
								<img class="" alt="" src="${e.target.result}">
								<div class="remove"></div>
							</div>
						`;
						$formGroup.append(previewHtml);
					};
					reader.readAsDataURL(file);
				}
			});

			// Handle remove functionality
			$formGroup.on('click', '.remove', function () {
				$(this).closest('.preview-image').remove();
				$input.val(''); // Clear the input value
			});
		});
	},
	formSubmit: () => {
		$('#form-submit').on('submit', function (e) {
			e.preventDefault();
			console.log('submit');
		});
	},
	validationForm: () => {
	},
	formRepeater: () => {
		// Initialize each repeater form
		$('.form-wrap-repeater').each(function () {
			const $formWrapper = $(this);
			const formId = $formWrapper.attr('id');
			const repeaterType = formId.replace('form-repeater-', '');
			let repeaterIndex = $formWrapper.find('.item-form-repeater').length;

			// Create global function for this repeater
			window[formId] = {
				getData: function () {
					return getRepeaterData($formWrapper, repeaterType);
				},
				save: function () {
					return saveRepeaterData($formWrapper, repeaterType);
				}
			};

			// Add new repeater item
			$(document).on('click', `#${formId} .btn-add-repeater`, function () {
				const $repeaterContainer = $(this).closest('.wrap-box').find('.form-list-repeater');
				const newItemHtml = `
					<div class="item-form-repeater form-2-columns" data-index="${repeaterIndex}">
						<div class="form-group">
							<label for="">Ngành học</label>
							<input type="text" name="${repeaterType}[${repeaterIndex}][field]" placeholder="Nhập ngành học" class="input-form">
						</div>
						<div class="form-group">
							<label for="">Trường học</label>
							<input type="text" name="${repeaterType}[${repeaterIndex}][school]" placeholder="Nhập trường học" class="input-form">
						</div>
						<div class="repeater-remove-btn">
							<button type="button" class="btn btn-remove-repeater">
								<i class="fa-regular fa-trash text-xl"></i>
								<span>Xóa</span>
							</button>
						</div>
					</div>
				`;

				$repeaterContainer.append(newItemHtml);
				repeaterIndex++;

				// Update remove button visibility for this specific repeater
				updateRemoveButtonsVisibility($formWrapper);
			});
		});

		// Remove repeater item
		$(document).on('click', '.btn-remove-repeater', function () {
			const $item = $(this).closest('.item-form-repeater');
			const $container = $item.closest('.form-list-repeater');
			const $formWrapper = $item.closest('.form-wrap-repeater');
			const formId = $formWrapper.attr('id');
			const repeaterType = formId.replace('form-repeater-', '');

			$item.remove();

			// Re-index remaining items
			reindexRepeaterItems($container, repeaterType);

			// Update remove button visibility for this specific repeater
			updateRemoveButtonsVisibility($formWrapper);
		});


		// Function to get repeater data as JSON
		function getRepeaterData ($formWrapper, repeaterType) {
			const data = [];
			$formWrapper.find('.item-form-repeater').each(function (index) {
				const $item = $(this);
				const field = $item.find(`input[name="${repeaterType}[${index}][field]"]`).val();
				const school = $item.find(`input[name="${repeaterType}[${index}][school]"]`).val();

				if (field || school) { // Only add if at least one field has value
					data.push({
						field: field,
						school: school
					});
				}
			});
			return data;
		}

		// Function to save repeater data
		function saveRepeaterData ($formWrapper, repeaterType) {
			$formWrapper.find('.btn-remove-repeater').hide();
			const data = getRepeaterData($formWrapper, repeaterType);
			console.log(data);
			return {
				type: repeaterType,
				data: data,
				saved: true,
				timestamp: new Date().toISOString()
			};
		}

		// Function to re-index repeater items after removal
		function reindexRepeaterItems ($container, repeaterType) {
			$container.find('.item-form-repeater').each(function (index) {
				$(this).attr('data-index', index);
				$(this).find('input[name*="[field]"]').attr('name', `${repeaterType}[${index}][field]`);
				$(this).find('input[name*="[school]"]').attr('name', `${repeaterType}[${index}][school]`);
			});
		}

		// Function to show/hide remove buttons based on item count
		function updateRemoveButtonsVisibility ($formWrapper) {
			const $items = $formWrapper.find('.item-form-repeater');
			if ($items.length <= 1) {
				$items.find('.btn-remove-repeater').hide();
			} else {
				$items.find('.btn-remove-repeater').show();
			}
		}

		// Initialize remove button visibility on page load for all repeaters
		$('.form-wrap-repeater').each(function () {
			updateRemoveButtonsVisibility($(this));
		});
	},
	uploadBanner: () => {
		$('input[name="account-profile-banner"]').on('change', function (e) {
			const file = e.target.files[0];
			if (file && file.type.startsWith('image/')) {
				const $coverImage = $('.cover-section .img-load');
				const $img = $coverImage.find('img');

				// Add loading class
				$coverImage.addClass('loading');

				const reader = new FileReader();
				reader.onload = function (e) {
					// Simulate loading delay
					setTimeout(() => {
						if ($img.length) {
							$img.attr('src', e.target.result);
						} else {
							$coverImage.html(`<img src="${e.target.result}" alt="Cover Image">`);
						}
						$coverImage.removeClass('loading');
					}, 2000);
				};
				reader.readAsDataURL(file);
			}
		});
	},
	uploadAvatar: () => {
		$('input[name="account-profile-avatar"]').on('change', function (e) {
			const file = e.target.files[0];
			if (file && file.type.startsWith('image/')) {
				const $avatarImage = $('.avatar-image.img-load');
				const $img = $avatarImage.find('img');
				// Add loading class
				$avatarImage.addClass('loading');
				const reader = new FileReader();
				reader.onload = function (e) {
					// Simulate loading delay
					setTimeout(() => {
						if ($img.length) {
							$img.attr('src', e.target.result);
						} else {
							$avatarImage.html(`<img src="${e.target.result}" alt="Avatar Image">`);
						}
						$avatarImage.removeClass('loading');
					}, 2000);
				};
				reader.readAsDataURL(file);
			}
		});
	},
	init: () => {
		form.inputDate();
		form.inputFile();
		form.select2();
		form.formSubmit();
		form.formRepeater();
		form.uploadBanner();
		form.uploadAvatar();
	}
}